import { useNavigate } from "react-router-dom";
import { RouterName } from "core/router";
import { Swiper, SwiperSlide } from "swiper/react";

import { Pagination } from "swiper/modules";
import Onboarding1Image from "../assets/images/onboarding-1.svg";//old .jpg
import Onboarding2Image from "../assets/images/onboarding-2.svg"; //old .jpg
import { useState } from "react";
import { Button } from "core/components/form-controls";
import { _t } from "core/language";
import LazyLoadImageComponent from "core/components/LazyLoadImage";

const IMAGE_ONBOARDING = [
  {
    id: 1,
    image: Onboarding1Image,
    alt: "Onboarding Image",
    title1: "main.title_first_1",
    title2: "main.title_second_1",
    content: "main.content_1",
  },
  {
    id: 2,
    image: Onboarding2Image,
    alt: "Onboarding Image",
    title1: "main.title_first_2",
    title2: "main.title_second_2",
    content: "main.content_2",
  },
];

const OnboardingPage = () => {
  const navigate = useNavigate();
  console.log((window as any)._APP_LANG);

  const handleBoarded = () => {
    localStorage.setItem("recipe_onBoarded", "true");
    navigate(RouterName.MAIN);
  };
  const [showButton, setShowButton] = useState<boolean>(false);
  const onSlideChange = (swiper: any) => {
    if (swiper.slides.length - 1 === swiper.activeIndex) {
      setShowButton(true);
      window.scrollTo({
        top: 0, // old scroll is document.body.scrollHeight
        behavior: "smooth",
      });
    } else {
      setShowButton(false);
    }
  };

  return (
    <div className={`h-full relative cus-onboarding min-h-[100vh] ${showButton ? ' cus-onboarding-has-btn' : ''}`}>
      <Swiper
        pagination={{
          clickable: true,
          bulletClass: "swiper-pagination-bullet", // Customize bullet class
          bulletActiveClass: "swiper-pagination-bullet-active", // Customize active bullet class
        }}
        modules={[Pagination]}
        className={`mySwiper h-[${showButton ? "80vh" : "95vh"}]`}
        onSlideChange={onSlideChange}
      >
        {IMAGE_ONBOARDING.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="mx-9 mt-[70px]">
              <h2 className="text-[22px] font-bold">{_t(item.title1)}</h2>
              <h2 className="text-[22px] font-bold text-primary">
                {_t(item.title2)}
              </h2>
              <p className="text-sm mt-3.5 font-normal mb-1 text-[#777777]">
                {_t(item.content)}
              </p>
            </div>
            <LazyLoadImageComponent
              src={item.image}
              alt={item.alt}
              className="w-full mt-8 object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {showButton ? (
        <div className="px-4 fixed bottom-[50px] left-0 w-full z-50">
          <Button
            size="lg"
            primary
            label={_t("main.get_start")}
            onClickBtn={handleBoarded}
            classBtn="w-full "
          />
        </div>
      ) : (
        <span
          className="absolute bottom-[75px] right-10 z-50 text-sm text-[#cccccc] text-[14px]"
          onClick={handleBoarded}
        >
          Skip
        </span>
      )}
    </div>
  );
};

export default OnboardingPage;
